import { render, staticRenderFns } from "./CargoVehicleDeparturesList.vue?vue&type=template&id=472f243b"
import script from "./CargoVehicleDeparturesList.vue?vue&type=script&lang=js"
export * from "./CargoVehicleDeparturesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports